import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/010-upload.png';
const _withScopeId = n => (_pushScopeId("data-v-306b64a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "single main"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "single-header"
}, [/*#__PURE__*/_createElementVNode("h2", {
  class: "single-title"
}, "单图处理工具"), /*#__PURE__*/_createElementVNode("p", {
  class: "single-desc"
}, "选择您需要的图片处理工具，轻松实现各种图片处理功能")], -1));
const _hoisted_3 = {
  class: "single-container"
};
const _hoisted_4 = {
  class: "tool-selector"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "选择处理工具", -1));
const _hoisted_6 = {
  class: "single-top"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "upload-content"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "upload-icon",
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("将图片拖拽至此，或 "), /*#__PURE__*/_createElementVNode("em", null, "点击上传")]), /*#__PURE__*/_createElementVNode("p", {
  class: "upload-tip"
}, "支持JPG、PNG、WEBP等格式")])], -1));
const _hoisted_8 = {
  class: "file-list"
};
const _hoisted_9 = {
  class: "file-list-header"
};
const _hoisted_10 = {
  class: "file-list-actions"
};
const _hoisted_11 = {
  class: "file-list-content"
};
const _hoisted_12 = {
  class: "file-list-bot"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-download"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_ImgAddLogo = _resolveComponent("ImgAddLogo");
  const _component_ImgRotate = _resolveComponent("ImgRotate");
  const _component_ImgScale = _resolveComponent("ImgScale");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_param_form = _resolveComponent("param-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_file_item = _resolveComponent("file-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_radio_group, {
    modelValue: $data.radioA,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.radioA = $event),
    class: "tool-radio-group"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_radio, {
      label: "1"
    }, {
      default: _withCtx(() => [_createTextVNode("长图处理")]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: "2"
    }, {
      default: _withCtx(() => [_createTextVNode("图片添加水印")]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: "3",
      disabled: ""
    }, {
      default: _withCtx(() => [_createTextVNode("图片去除水印")]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: "4"
    }, {
      default: _withCtx(() => [_createTextVNode("图片旋转")]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: "5"
    }, {
      default: _withCtx(() => [_createTextVNode("图片放大缩小")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [$data.radioA === '2' ? (_openBlock(), _createBlock(_component_ImgAddLogo, {
    key: 0,
    class: "upload-logo"
  })) : _createCommentVNode("", true), $data.radioA === '4' ? (_openBlock(), _createBlock(_component_ImgRotate, {
    key: 1,
    class: "upload-logo"
  })) : _createCommentVNode("", true), $data.radioA === '5' ? (_openBlock(), _createBlock(_component_ImgScale, {
    key: 2,
    class: "upload-logo"
  })) : _createCommentVNode("", true), $data.radioA === '1' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createVNode(_component_el_upload, {
    class: "upload",
    drag: "",
    action: $data.baseUrl + 'dcwytimgapi/process/single',
    accept: $data.acceptImageFormats,
    "show-file-list": false,
    data: $options.uploadOptions,
    "file-list": $data.fileList,
    "onUpdate:fileList": _cache[1] || (_cache[1] = $event => $data.fileList = $event)
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  }, 8, ["action", "accept", "data", "file-list"]), _createVNode(_component_param_form, {
    class: "single-form",
    type: "single",
    form: $data.options
  }, null, 8, ["form"])], 64)) : _createCommentVNode("", true)]), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("h3", null, "已上传文件 (" + _toDisplayString($data.fileList.length) + ")", 1), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
      size: "small",
      onClick: $options.clearFileList,
      icon: "el-icon-delete"
    }, {
      default: _withCtx(() => [_createTextVNode("清空列表")]),
      _: 1
    }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileList, file => {
      return _openBlock(), _createBlock(_component_file_item, {
        file: file,
        key: file.uid
      }, null, 8, ["file"]);
    }), 128))]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.downloadAll,
      disabled: $data.fileList.length === 0
    }, {
      default: _withCtx(() => [_hoisted_13, _createTextVNode(" 下载全部 ")]),
      _: 1
    }, 8, ["onClick", "disabled"])])], 512), [[_vShow, $data.fileList.length]])]),
    _: 1
  })])]);
}